import GitInfo from 'react-git-info/macro'
import packageJson from '../package.json'

// monorepo path filter verified
const gitInfo = GitInfo()

export const SERVER_NAME = {
  KOREA: 'korea',
  KOREA_DEV: 'korea-dev',
  KOREA_STAGING: 'korea-staging',
  KOREA_QC: 'qc',
  JAPAN: 'japan',
  JAPAN_DEV: 'japan-dev',
  JAPAN_STAGING: 'japan-staging',
  US: 'us',
  US_DEV: 'us-dev',
  US_STAGING: 'us-staging',
  PRODUCTION: 'production',
}

let confProp
if (process.env.REACT_APP_TARGET === SERVER_NAME.PRODUCTION) {
  if (process.env.REACT_APP_SERVER === SERVER_NAME.KOREA) {
    confProp = {
      DEBUG: false,
      SERVER: {
        authURL: 'https://auth.officemail.io/api/v1',
        URL: 'https://api.officemail.io/graphql',
        orgChartURL: 'https://orgchart.officemail.io/v1',
        officeNextURL: 'https://api.officenext.net',
        safeboxURL: 'https://api.officepassword.kr',
        logoApiURL: 'https://api.logo.bi',
        wsAddress: null,
        wsURL: null,
      },
      officeNextURL: 'https://org.officenext.net',
    }
  } else if (process.env.REACT_APP_SERVER === SERVER_NAME.JAPAN) {
    confProp = {
      DEBUG: false,
      SERVER: {
        authURL: 'https://auth.officemail.jp/api/v1',
        URL: 'https://api.officemail.io/graphql',
        orgChartURL: 'https://orgchart.officemail.io/v1',
        officeNextURL: 'https://api.officenext.net',
        safeboxURL: 'https://api.safepassword.jp',
        logoApiURL: 'https://api.logo.bi',
        wsAddress: null,
        wsURL: null,
      },
      officeNextURL: 'https://org.officenext.net',
    }
  } else if (process.env.REACT_APP_SERVER === SERVER_NAME.US) {
    confProp = {
      DEBUG: false,
      SERVER: {
        authURL: 'https://auth.officemail.jp/api/v1',
        URL: 'https://api.officemail.io/graphql',
        orgChartURL: 'https://orgchart.officemail.io/v1',
        officeNextURL: 'https://api.officenext.net',
        safeboxURL: 'https://api.safepassword.io',
        logoApiURL: 'https://api.logo.bi',
        wsAddress: null,
        wsURL: null,
      },
      officeNextURL: 'https://org.officenext.net',
    }
  } else {
    confProp = {
      DEBUG: false,
      SERVER: {
        authURL: 'https://auth.officemail.io/api/v1',
        URL: 'https://api.officemail.io/graphql',
        orgChartURL: 'https://orgchart.officemail.io/v1',
        officeNextURL: 'https://api.officenext.net',
        safeboxURL: 'https://api.officepassword.kr',
        logoApiURL: 'https://api.logo.bi',
        wsAddress: null,
        wsURL: null,
      },
      officeNextURL: 'https://org.officenext.net',
    }
  }
} else if (process.env.REACT_APP_TARGET === SERVER_NAME.KOREA_DEV) {
  confProp = {
    DEBUG: false,
    SERVER: {
      authURL: 'https://auth.officemail.app/api/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      orgChartURL: 'https://orgchart.officemail.app/v1',
      officeNextURL: 'https://stage-api.officenext.net',
      safeboxURL: 'https://dev-api.officepassword.kr',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://stage-org.officenext.net',
  }
} else if (process.env.REACT_APP_TARGET === SERVER_NAME.JAPAN_DEV) {
  confProp = {
    DEBUG: false,
    SERVER: {
      authURL: 'https://dev-auth.officemail.jp/api/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      orgChartURL: 'https://orgchart.officemail.app/v1',
      officeNextURL: 'https://stage-api.officenext.net',
      safeboxURL: 'https://dev-api.safepassword.jp',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://stage-org.officenext.net',
  }
} else if (process.env.REACT_APP_TARGET === SERVER_NAME.US_DEV) {
  confProp = {
    DEBUG: false,
    SERVER: {
      authURL: 'https://dev-auth.officemail.jp/api/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      orgChartURL: 'https://orgchart.officemail.app/v1',
      officeNextURL: 'https://stage-api.officenext.net',
      safeboxURL: 'https://dev-api.safepassword.io',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://stage-org.officenext.net',
  }
} else if (process.env.REACT_APP_TARGET === SERVER_NAME.KOREA_STAGING) {
  confProp = {
    DEBUG: false,
    SERVER: {
      authURL: 'https://auth.officemail.app/api/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      orgChartURL: 'https://orgchart.officemail.app/v1',
      officeNextURL: 'https://stage-api.officenext.net',
      safeboxURL: 'https://staging-api.safebox.biz',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://stage-org.officenext.net',
  }
} else if (process.env.REACT_APP_TARGET === SERVER_NAME.KOREA_QC) {
  confProp = {
    DEBUG: false,
    SERVER: {
      authURL: 'https://qc-auth.officemail.app/api/v1',
      URL: 'https://qc-api.officemail.io/graphql',
      orgChartURL: 'https://qc-orgchart.officemail.app/v1',
      // TODO: officeNextURL 미정 — 확정되면 교체 (현재 stage 값 placeholder)
      officeNextURL: 'https://stage-api.officenext.net',
      safeboxURL: 'https://qc-api.officepassword.kr',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    // TODO: officeNextURL 미정 — 확정되면 교체 (현재 stage 값 placeholder)
    officeNextURL: 'https://stage-org.officenext.net',
  }
} else if (process.env.REACT_APP_TARGET === SERVER_NAME.JAPAN_STAGING) {
  confProp = {
    DEBUG: false,
    SERVER: {
      authURL: 'https://auth-jp.officemail.app/api/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      orgChartURL: 'https://orgchart.officemail.app/v1',
      officeNextURL: 'https://stage-api.officenext.net',
      safeboxURL: 'https://dev-api.safepassword.jp',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://stage-org.officenext.net',
  }
} else if (process.env.REACT_APP_TARGET === SERVER_NAME.US_STAGING) {
  confProp = {
    DEBUG: false,
    SERVER: {
      authURL: 'https://auth-jp.officemail.app/api/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      orgChartURL: 'https://orgchart.officemail.app/v1',
      officeNextURL: 'https://stage-api.officenext.net',
      safeboxURL: 'https://dev-api.safepassword.io',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://stage-org.officenext.net',
  }
} else {
  confProp = {
    DEBUG: false,
    SERVER: {
      authURL: 'https://dev-api.officemail.io/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      orgChartURL: 'https://dev-api.officemail.io/v1',
      officeNextURL: 'https://stage-api.officenext.net',
      safeboxURL: 'https://192.168.50.100:8686',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://stage-org.officenext.net',
  }
}

export function isKR() {
  return (
    process.env.REACT_APP_SERVER === SERVER_NAME.KOREA ||
    process.env.REACT_APP_TARGET === SERVER_NAME.KOREA_DEV ||
    process.env.REACT_APP_TARGET === SERVER_NAME.KOREA_STAGING ||
    process.env.REACT_APP_TARGET === SERVER_NAME.KOREA_QC
  )
}

export function isJP() {
  return (
    process.env.REACT_APP_SERVER === SERVER_NAME.JAPAN ||
    process.env.REACT_APP_TARGET === SERVER_NAME.JAPAN_DEV ||
    process.env.REACT_APP_TARGET === SERVER_NAME.JAPAN_STAGING
  )
}

export function isUS() {
  return (
    process.env.REACT_APP_SERVER === SERVER_NAME.US ||
    process.env.REACT_APP_TARGET === SERVER_NAME.US_DEV ||
    process.env.REACT_APP_TARGET === SERVER_NAME.US_STAGING
  )
}

export function isGlobal() {
  return isJP() || isUS()
}

const defaultLocale = () => {
  if (isJP()) {
    return 'ja-JP'
  }
  if (isUS()) {
    return 'en-US'
  }
  return window.navigator.language || window.navigator.userLanguage || 'ko-KR'
}

confProp.defaultLocale = defaultLocale()

if (window.globalConfig != null) {
  if (window.globalConfig.restURL != null) {
    confProp.SERVER.orgChartURL = window.globalConfig.restURL
  }
  if (window.globalConfig.URL != null) {
    confProp.SERVER.URL = window.globalConfig.URL
  }
  if (window.globalConfig.LOCALE != null) {
    confProp.defaultLocale = window.globalConfig.LOCALE
  }
}

confProp.gitInfo = gitInfo
confProp.packageInfo = packageJson

const conf = confProp

export default conf
